import { createElement, FC } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from '@ebsco-ui/ebsco-ui';

import { sharedMessages } from '@app/translations';
import { ShapeWithClassName } from '@app/constants';

interface ModalHeaderProps {
  title?: string;
  titleLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  onClose: () => void;
}

export const ModalHeader: FC<ShapeWithClassName<ModalHeaderProps>> = ({
  title,
  titleLevel = 3,
  className,
  children,
  onClose,
}) => {
  const { $t } = useIntl();

  return (
    <Modal.Header
      className={className}
      closeButtonProps={{
        title: $t(sharedMessages.close),
        autoFocus: true,
        onClick: onClose,
      }}
    >
      {title && createElement(`h${titleLevel}`, null, title)}
      {children}
    </Modal.Header>
  );
};
